


import React from 'react'
import Axis from './Axis'

export default ({ scales, margins, svgDimensions,show_ticks }) => {
    const { height, width } = svgDimensions;

    const xProps = {
        orient: 'Bottom',
        scale: scales.xScale,
        translate: `translate(0, ${height - margins.bottom})`,
        tickSize: height - margins.top - margins.bottom,
        show_ticks:show_ticks
    };

    const yProps = {
        orient: 'Left',
        scale: scales.yScale,
        translate: `translate(${margins.left}, 0)`,
        tickSize: width - margins.left - margins.right,
        show_ticks:show_ticks
    };

    return (
        <g>
            <Axis {...xProps}  />
            <Axis {...yProps}  />
        </g>
    )
}